module.exports = __webpack_public_path__ + "assets/a612aaec761ef01a91e655e9a4867ff5.mp3";